/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CustomerActivationControllerService } from './services/customer-activation-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CustomerActivationControllerService,
    ApiConfiguration
  ],
})
export class CustomersActivationModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersActivationModule> {
    return {
      ngModule: CustomersActivationModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersActivationModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersActivationModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
